import { redirect, type RouteObject } from 'react-router-dom';

export const accessRoute: RouteObject = {
  path: 'access',
  children: [
    // The sidebar renders "Access" itself as a link; send it to the first child.
    {
      path: '',
      loader: () => redirect('roles'),
    },
    {
      path: 'roles',
      lazy: () => import('./roles'),
    },
    {
      path: 'members',
      lazy: () => import('./members'),
    },
  ],
};
